import { useQuery } from 'react-query'
import { companyTypeList } from 'services/api'
import { SupportedCountries } from 'services/api/endpoints/risikaAPI/lists/companyTypeList'

export function useCompanyTypeList(country: SupportedCountries) {
  return useQuery(['companyTypeList', country], () => companyTypeList(country), {
    refetchOnWindowFocus: false,
  })
}
